// Device ID tracking utility for anonymous users
import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = 'loo_report_device_id';
const DEVICE_STATS_KEY = 'loo_report_device_stats';

/**
 * Get or create a unique device ID
 * This ID persists in localStorage and is used to track anonymous contributions
 */
export const getDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  
  return deviceId;
};

/**
 * Get cached device stats
 */
export const getCachedDeviceStats = () => {
  const stats = localStorage.getItem(DEVICE_STATS_KEY);
  return stats ? JSON.parse(stats) : null;
};

/**
 * Cache device stats locally
 */
export const cacheDeviceStats = (stats) => {
  localStorage.setItem(DEVICE_STATS_KEY, JSON.stringify(stats));
};

/**
 * Check if user should be prompted to add email
 * (after 5 contributions)
 */
export const shouldPromptForEmail = (stats) => {
  if (!stats) return false;
  return stats.should_prompt_email && !stats.is_linked;
};

/**
 * Mark email prompt as dismissed
 */
export const dismissEmailPrompt = () => {
  const stats = getCachedDeviceStats();
  if (stats) {
    stats.should_prompt_email = false;
    cacheDeviceStats(stats);
  }
};

export default {
  getDeviceId,
  getCachedDeviceStats,
  cacheDeviceStats,
  shouldPromptForEmail,
  dismissEmailPrompt
};
